import fetch from "auth/FetchInterceptor"

class DisputeService {
  getAll(params = {}) {
    const searchParams = new URLSearchParams()

    if (params.status) {
      searchParams.set("status", params.status)
    }

    if (typeof params.page === "number") {
      searchParams.set("page", String(params.page))
    }

    if (typeof params.pageSize === "number") {
      searchParams.set("pageSize", String(params.pageSize))
    }

    if (typeof params.search === "string" && params.search.trim()) {
      searchParams.set("search", params.search.trim())
    }

    if (params.sortBy) {
      searchParams.set("sortBy", params.sortBy)
    }

    if (params.priorityLevel) {
      searchParams.set("priorityLevel", params.priorityLevel)
    }

    if (params.stepperStep) {
      searchParams.set("stepperStep", params.stepperStep)
    }

    const query = searchParams.toString()

    return fetch({
      url: `/disputes/partner${query ? `?${query}` : ""}`,
      method: "get",
    })
  }

  getById(id) {
    return fetch({
      url: `/disputes/partner/${id}`,
      method: "get",
    })
  }

  ignore(id, reason) {
    return fetch({
      url: `/disputes/${id}/ignore`,
      method: "put",
      data: { reason },
    })
  }

  accept(id, message) {
    return fetch({
      url: `/disputes/${id}/accept`,
      method: "put",
      data: { message },
    })
  }

  quickAction(id, data) {
    return fetch({
      url: `/disputes/${id}/quick-action`,
      method: "put",
      data,
    })
  }

  getHistory(id) {
    return fetch({
      url: `/disputes/${id}/history`,
      method: "get",
    })
  }

  exportPdf(id) {
    return fetch({
      url: `/disputes/partner/${id}/export-pdf`,
      method: "get",
      responseType: "blob",
    })
  }
}

export default new DisputeService()
